import React, { Component } from 'react';
import {
    Table, Card, Row, Col,
} from 'antd';
import { Link } from 'react-router-dom';
import AdminCompaniesAddContainer from '../containers/AdminCompaniesAddContainer';

class AdminCompaniesView extends Component {
    render() {
        const columns = [{
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text, row) => (
                <Link to={`/admin/company/${row.key}`}>
                    {text}
                </Link>
            ),
        }, {
            title: 'Direccion',
            dataIndex: 'address',
            key: 'address',
        }, {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        }];

        return (
            <div>
                <Row gutter={16}>
                    <Col span={16}>
                        <Card title="Empresas" style={{ width: '100%' }}>
                            <Table dataSource={this.props.companies} columns={columns} />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card title="Agregar Empresa" style={{ width: '100%' }}>
                            <AdminCompaniesAddContainer />
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default AdminCompaniesView;



// WEBPACK FOOTER //
// ./src/components/views/AdminCompaniesView.js